import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ConfigService } from '@core/services/config.service';
import { LanguageService } from '@i18n/services/language.service';
import { LoginService } from '@core/services/login.service';
import { MsalService } from '@azure/msal-angular';
import { Logger } from '@azure/msal-browser';

@Component({
  selector: 'mfp-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
  constructor(
    private configService: ConfigService,
    private languageService: LanguageService,
    private loginService: LoginService,
    private authService: MsalService
  ) {
    //window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
  }

  ngOnInit() {
    this.languageService.onLangChange.subscribe({
      next: () => this.configService.updateConfig().subscribe()
    });
  }

  /*ngOnDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
  }

  @HostListener('window:beforeunload', ['$event'])
  async beforeUnloadHandler(event: any) {
    await this.logoutBeforeUnload();
    event.preventDefault();
  }

  async logoutBeforeUnload() {
    // Lógica para el logout antes de descargar la ventana
    this.loginService.onLogout();
    this.authService.logoutRedirect();
  }*/
}
